import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCards = ({ stats }) => {
  
  const statItems = [
    {
      id: 'total',
      label: 'Total Cards',
      value: stats.totalCards,
      icon: 'CreditCard',
      color: 'text-accent',
      bgColor: 'bg-accent/20'
    },
    {
      id: 'active',
      label: 'Active Cards',
      value: stats.activeCards,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/20'
    },
    {
      id: 'restricted',
      label: 'Restricted Cards',
      value: stats.restrictedCards,
      icon: 'XCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/20'
    },
    {
      id: 'inactive',
      label: 'Inactive Cards',
      value: stats.inactiveCards,
      icon: 'MinusCircle',
      color: 'text-text-muted',
      bgColor: 'bg-text-muted/20'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statItems.map((item) => (
        <div
          key={item.id}
          className="bg-surface border border-border rounded-lg p-6 hover:shadow-elevation-1 transition-shadow duration-150"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-text-muted mb-1">
                {item.label}
              </p>
              <p className="text-2xl font-bold text-text-primary">
                {item.value.toLocaleString()}
              </p>
            </div>
            <div className={`w-12 h-12 ${item.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={item.icon} size={24} className={item.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;